import type { ShiftRecord, ShiftRQSchema } from '@libs/data-access/queries'
import type { ReduxState } from '@spa/redux/ReduxState'
import { useMemoSelector } from '@spa/redux/hooks'
import { getOwnMembershipValidation } from '@spa/scenes/Plannings/redux/selectors'
import { getContractById } from 'snap-redux/modules/contracts/selectors'
import { getCurrentMembershipSelector } from 'snap-redux/modules/memberships/selectors'
import { useRoleRights } from 'snap-redux/modules/memberships/utils'

/**
 * @deprecated file
 */

const useRealFormValidationPermission = ({
  shiftData,
  precomputedCanValidate
}: {
  shiftData?: ShiftRecord | ShiftRQSchema
  precomputedCanValidate?: boolean
}) => {
  const shift =
    useMemoSelector((state: ReduxState) =>
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      state.shifts.getIn(['data', shiftData.id])
    ) || shiftData

  // FROM PLANNED

  // ----------------

  // FROM UNPLANNED
  const { atLeast, exact } = useRoleRights()
  const shiftWeeklyscheduleId = shift.weeklyschedule_id

  const shiftWeeklyschedule = useMemoSelector((state: ReduxState) =>
    state.weeklyschedules.getIn(['data', shiftWeeklyscheduleId])
  )

  const currentMembership = useMemoSelector(getCurrentMembershipSelector)
  const shiftContract = useMemoSelector((state: ReduxState) =>
    getContractById(state, shift.user_contract_id)
  )

  const canValidateOwnShift = useMemoSelector(state =>
    getOwnMembershipValidation(state, {
      membershipId: currentMembership.id,
      policyKey: 'canValidateOwnRealHours'
    })
  )

  const computeValidationPermissionFromWeeklyschedule = () => {
    // Others views permission computation
    const isOwnShift = shiftContract.membership_id === currentMembership.id

    const canValidateOwnShiftIfManager = isOwnShift ? canValidateOwnShift : true
    /*
     * If a manager cannot validate his own shift
     * Then we consider them as an employee
     */
    const canValidateIfManager = exact.manager
      ? canValidateOwnShiftIfManager
      : atLeast.manager

    return Boolean(
      shiftWeeklyschedule?.permissions?.get('can_validate') &&
        canValidateIfManager
    )
  }

  // For Month View V2, the permissions are already provided by the backend
  const canValidate =
    precomputedCanValidate ?? computeValidationPermissionFromWeeklyschedule()

  return canValidate
}

/**
 * @deprecated file
 */
export default useRealFormValidationPermission
